import buyerReducer from '@/state/modules/buyer/reducers';

export { default as actions } from '@/state/modules/buyer/actions';
export { default as sagas } from '@/state/modules/buyer/sagas';
export { default as operations } from '@/state/modules/buyer/operations';
export { default as selectors } from '@/state/modules/buyer/selectors';

export default buyerReducer;
